import React, { useState, useEffect } from 'react';
import startIcon from '../assets/StartIcon.png';
import StartMenu from './StartMenu';
import { FaEnvelope, FaGithub, FaInstagram, FaLink, FaLinkedin, FaSearch } from 'react-icons/fa';
import { IoDocumentAttachOutline } from "react-icons/io5";
import StartMenuModal from './StartMenuModal';
import HelpModal from './HelpModal';

const Footer = () => {
  const [dateTime, setDateTime] = useState(new Date());
  const [isStartMenuVisible, setIsStartMenuVisible] = useState(false);
  const [modals, setModals] = useState([]);
  const [isHelpModalVisible, setIsHelpModalVisible] = useState(false);

  const handleDoubleClick = (title, data) => {
    const newModal = {
      id: new Date().getTime(),
      title: title,
      data: data,
    };
    setModals([...modals, newModal]);
    toggleStartMenu()
  };

  const toggleHelpModal = () => {
    setIsHelpModalVisible(!isHelpModalVisible);
  };

  const closeModal = (id) => {
    setModals(modals.filter(modal => modal.id !== id));
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setDateTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatDate = (date) => {
    const options = { weekday: 'short', month: 'short', day: 'numeric' };
    return date.toLocaleDateString('en-US', options);
  };

  const formatTime = (date) => {
    return date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
  };

  const toggleStartMenu = () => {
    setIsStartMenuVisible(!isStartMenuVisible);
  };


  return (
    <div className="absolute bottom-0 w-full">
      <div className="absolute bottom-0 w-full flex justify-between items-center bg-gray-800 p-2">
        <div className="flex items-center space-x-4">
          {/* Start menu icon */}
          <img
            src={startIcon}
            alt="Start Menu"
            className="w-8 h-8 cursor-pointer"
            onClick={toggleStartMenu}
          />
          
          {/* Search bar */}
          <div className="flex items-center bg-gray-700 p-1 rounded-md">
            <FaSearch color='#fff' className='ml-1'/>
            <input
              type="text"
              placeholder="Type here to search"
              className="bg-gray-700 text-white outline-none ml-3"
            />
          </div>
          
          {/* Pinned applications */}
          <div className="flex items-center space-x-4 gap-2">
            <a href="mailto:smitkbgd@gmail.com" target="_blank" rel="noopener noreferrer">
              <FaEnvelope className="w-8 h-8 text-white" />
            </a>
            <a href="https://github.com/Smitkhobragade" target="_blank" rel="noopener noreferrer">
              <FaGithub className="w-8 h-8 text-white" />
            </a>
            <a href="https://www.linkedin.com/in/smit-khobragade/" target="_blank" rel="noopener noreferrer">
              <FaLinkedin className="w-8 h-8 text-white" />
            </a>
            <a href="https://www.instagram.com/smit_kbgd/" target="_blank" rel="noopener noreferrer">
              <FaInstagram className="w-8 h-8 text-white" />
            </a>
            <a href="https://linktr.ee/smitkhobragade" target="_blank" rel="noopener noreferrer">
              <FaLink className="w-8 h-8 text-white" />
            </a>
            <a href="https://drive.google.com/file/d/122Pvox8NpAuqOwJ19DeFM09FNPo4mwqD/view?usp=drive_link" target="_blank" rel="noopener noreferrer">
              <IoDocumentAttachOutline className="w-8 h-8 text-white" />
            </a>
          </div>
        </div>

        {/* Date and Time */}
        <div className='flex flex-row gap-4'>
          <div className="flex flex-col-reverse text-sm items-center space-x-2 text-white">
            <span>{formatDate(dateTime)}</span>
            <span>{formatTime(dateTime)}</span>
          </div>

          <button 
            onClick={toggleHelpModal}
            className="bg-blue-600 text-white px-4 py-2 rounded-md"
          >
            Help
          </button>
        </div>
        
      </div>

      

      {/* Start Menu Modal*/}
      <StartMenu isVisible={isStartMenuVisible} setIsStartMenuVisible={setIsStartMenuVisible} modals={modals} setModals={setModals} handleDoubleClick={handleDoubleClick} />
      <HelpModal isVisible={isHelpModalVisible} onClose={toggleHelpModal} />
      {modals.map(modal => (
        <StartMenuModal
          key={modal.id}
          id={modal.id}
          title={modal.title}
          data={modal.data}
          onClose={closeModal} />
      ))}
    </div>
  );
};

export default Footer;
